// @ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser } from "../auth/auth";
import { getAdminWaitlist } from "../api/admin";
import { useToast } from "../components/ToastProvider";
import "../styles/AdminReports.css";
import "../styles/AdminLogs.css";
import "../styles/AdminWaitlist.css";

export default function AdminWaitlist() {
  const navigate = useNavigate();
  const user = getUser();
  const { showToast } = useToast();
  const [entries, setEntries] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [favoriteGameOption, setFavoriteGameOption] = useState("all");

  const fetchWaitlist = useCallback(async () => {
    try {
      const params =
        query.trim() || favoriteGameOption !== "all"
          ? {
              query: query.trim() || undefined,
              favoriteGameOption: favoriteGameOption !== "all" ? favoriteGameOption : undefined,
            }
          : undefined;

      const data = await getAdminWaitlist(params);
      setEntries(Array.isArray(data?.items) ? data.items : []);
      setTotalCount(Number(data?.totalCount || 0));
    } catch (error) {
      if (error?.message?.toLowerCase?.().includes("forbidden")) {
        showToast("Unauthorized access", "error");
        navigate("/home");
        return;
      }
      showToast("Failed to load waitlist entries", "error");
    } finally {
      setLoading(false);
    }
  }, [favoriteGameOption, navigate, query, showToast]);

  useEffect(() => {
    if (!user || user.role !== "admin") {
      showToast("Unauthorized access", "error");
      navigate("/home");
      return;
    }

    fetchWaitlist();
  }, [user, navigate, fetchWaitlist, showToast]);

  const uniqueOptions = Array.from(new Set(entries.map((entry) => entry.favoriteGameOption).filter(Boolean)));

  if (loading) {
    return (
      <div className="admin-logs-page">
        <div className="loading">Loading waitlist entries...</div>
      </div>
    );
  }

  return (
    <div className="admin-logs-page admin-waitlist-page">
      <header className="admin-header">
        <button className="back-btn" onClick={() => navigate("/home")}>←</button>
        <div>
          <h1>Waitlist Management</h1>
          <p>Review everyone who joined the Cardex landing-page waitlist</p>
        </div>
      </header>

      <section className="admin-waitlist-summary">
        <div className="admin-waitlist-stat-card">
          <span className="admin-waitlist-stat-label">Total waitlist signups</span>
          <strong className="admin-waitlist-stat-value">{totalCount.toLocaleString()}</strong>
        </div>
        <div className="admin-waitlist-stat-card">
          <span className="admin-waitlist-stat-label">Visible results</span>
          <strong className="admin-waitlist-stat-value">{entries.length.toLocaleString()}</strong>
        </div>
      </section>

      <div className="admin-logs-toolbar admin-waitlist-toolbar">
        <select value={favoriteGameOption} onChange={(event) => setFavoriteGameOption(event.target.value)}>
          <option value="all">All favorite TCGs</option>
          {uniqueOptions.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
        <input
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search email or favorite game..."
        />
        <button className="refresh-btn" onClick={fetchWaitlist}>Refresh</button>
      </div>

      <div className="admin-logs-table admin-waitlist-table">
        <div className="admin-logs-table-head admin-waitlist-table-head">
          <div>Joined</div>
          <div>Email</div>
          <div>Favorite Game</div>
          <div>Selected Option</div>
          <div>Source</div>
        </div>
        {entries.length === 0 ? (
          <div className="admin-logs-empty">No waitlist entries found.</div>
        ) : (
          entries.map((entry) => (
            <div className="admin-logs-row admin-waitlist-row" key={entry.id}>
              <div>{new Date(entry.createdAt).toLocaleString()}</div>
              <div className="admin-waitlist-email">{entry.email}</div>
              <div><span className="action-pill">{entry.favoriteGame}</span></div>
              <div>{entry.favoriteGameOption}</div>
              <div>{entry.source || "cardex_landing"}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
